module.exports = __webpack_public_path__ + "09_mustache_grey.a5c2d1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/09_mustache_grey.png
// module id = DQHC
// module chunks = 0